import TigerBugsnag from '@tiger/bugsnag';
import { toJS } from 'mobx';
import pkg from 'package.json';
import APP from 'stores/APP';
import security from 'stores/security';
import ignores from './ignore';

const { ErrorBoundary } = TigerBugsnag({
    apiKey: pkg.bugsnag,
    extraEnv: APP,
    shouldReport:
        process.env.NODE_ENV === 'production' &&
        !/dev|test|localhost|\.uat\./i.test(window.location.host) &&
        window.location.protocol.startsWith('https'),
    getCurrentUser: () => {
        const currentUser = security.currentUser || security.__bugsnagUser;

        if (currentUser) {
            const userInfo = toJS(currentUser);

            // 上报用户信息
            return {
                ...userInfo,
                // 路由的访问权限是基于该字段判断的，额外上报该字段用于问题排查
                currentProcessStatus: security.currentProcessStatus
            };
        }

        return;
    },
    ignoreRules: ignores
});

export { ErrorBoundary };
